// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".swap-button[data-v-708b2834]{padding:.5rem;display:flex;align-items:center}", ""]);
// Exports
module.exports = exports;
